@import '../../../../node_modules/bootstrap/scss/close';

.alert {
	margin-bottom: 0;
	border-radius: 0;
	padding: $spacer 0;


	&-dismissible {

		.container {
			position: relative;
			padding-right: 3rem;
		}

		.btn-close {
			padding: 0;
			top: calc((-1 * #{$spacer}) + #{$gutter-sm});
			background-size: 13px 13px;
		}
	}

	.btn-close {
		position: absolute;
		top: 0;
		right: 0;
	}

	&.has-icon {
		
		> .container {
			padding-left: $spacer * 4;

			p{
				margin: 0 30px;
			}
	
			app-arrow-link{
				margin: 0 30px;
			}
		}

		.alert-icon {
			position: absolute;
			left: 0;
			height: 50px;
			width: 50px;

			svg {
				@include svg-format(100%, 100%, $primary);
			}
		}
		
	}

	// Client Scope
	&.app-alert {
		background-color: $secondary;
		border: none;
		padding: 20px 0;

		p {
			margin: 0;
			padding: 0;
			@include line-height(18);
			@include text-size(15);

			strong {
				@include text-size(16);
			}
		}

		strong {
			@include text-size(16);
		}

		[class^="arrow-link"] {
			@include text-size(12);

			.svg-icon {
				margin-right: 0;
			}

			&:last-child {
				margin: 8px 0 0;
			}
		}

		&.has-icon {
			> .container {
				padding-left: $spacer * 5;
			}
		}
	}

	@include media-breakpoint-down(md) {
		&-dismissible {
			.btn-close {
				padding: 0;
				top: calc((-1 * #{$spacer}) + #{$gutter-def});
				right: 35px;
				background-size: 13px 13px;
			}
		}

		&.app-alert {
			[class^="arrow-link"]:last-child,
			[class^="arrow-link"] {
				margin: $gutter-sm 0 0;
			}

			&.has-icon {
				> .container {
					padding: 0;
				}

				.alert-icon {
					margin: 6px auto 8px auto;
					position: relative;
					left: 0;
					height: 25px;
					width: 25px;
				}
			}

			p {
				font-size: 12px;
			}

			> .container {
				display: flex;
				flex-direction: column;
				padding: 0;
			}
		}
	}
}